import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { Card } from './card'
import type { MoveCardDto } from './cards-move.dto'

export class CardsRepository extends BaseRepository<Card> {
    constructor(
        private endpoint: string,
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        if (!endpoint) throw new Error('Constructor param required')

        super(config.pipelineApiUrl + '/' + endpoint, token, cache)
    }

    async move(cardId: string, dto: MoveCardDto) {
        const { json, statusCode, message } = await this.request.put(
            this.config.pipelineApiUrl +
                '/' +
                this.endpoint +
                '/' +
                cardId +
                '/?token=' +
                this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }
}
